import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory();

/**
 * アセスメント結果データ
 */
export interface IAssessmentResultData {
	/**
	 * アセスメント結果リスト情報
	 */
	assessmentResultList: IResultDataInfo[];

	/**
	 * スキル名
	 */
	careerName: string;

	/**
	 * カテゴリ利用フラグ
	 */
	categoryFlg: number;

	/**
	 * 平均値グラフ表示フラグ
	 */
	averageFlg: number;

	/**
	 * スキルから管理者のコメント
	 */
	comment: string;

	/**
	 * ランク名
	 */
	rankName: string;
}

/**
 * アセスメント結果リスト情報
 */
export interface IResultDataInfo {
	/**
	 * やや高い
	 */
	alittleHigh: number;

	/**
	 * アセスメントID
	 */
	assessmentId: string;

	/**
	 * 対象者全体平均
	 */
	allObjectAveragePercent: number;

	/**
	 * カテゴリ名
	 */
	scoreName: string;

	/**
	 * 非常に高い
	 */
	veryHigh: number;

	/**
	 * 高い
	 */
	high: number;

	/**
	 * 得分合計
	 */
	score: number;

	/**
	 * 最高分合計
	 */
	maxScore: number;

	/**
	 * 組織内平均
	 */
	orgAveragePercent: number;
}

/**
 * アセスメント結果データ設定
 */
export const setAssessmentResultData = actionCreator<IAssessmentResultData>(
	'SET_ASSESSMENT_RESULT_DATA'
);



// WEBPACK FOOTER //
// ./src/actions/assessmentResult.ts